import { Logo } from '../../../components'
import Form from './form'

export default function SignIn() {
  return (
    <main className="bg-[#242529] w-screen min-h-screen py-10 md:py-6 flex flex-col items-center justify-center">
      <div className="bg-[#37393F] grid rounded-lg gap-2 py-8 px-10 md:max-w-[50%] lg:max-w-[46%] xl:max-w-[34%]">
        <div className="w-max max-w-full mx-auto">
          <Logo className="p-0 m-0 max-w-[6rem]" />
        </div>

        <h1 className="text-center">
          Olá, bem-vindo ao sistema de gestão online da Winup
        </h1>

        <Form />
      </div>
    </main>
  )
}
